module.exports = __webpack_public_path__ + "static/products-intro-mobile-eb7319500775a8f2c47b6d85a62406bd.jpg";